import React from "react";
import "./WellSelection.scss";
import { Icons } from "@learningblocks/exp-constants";
import parse from "html-react-parser";

export type WellPosition = `${string}${number}`;

interface WellSelectionProps {
  selectedWells: WellPosition[];
  incorrectWells: WellPosition[];
  onRemoveWell: (position: WellPosition) => void;
  wellSelectionError: string;
}

const WellSelection = ({
  selectedWells,
  onRemoveWell,
  incorrectWells,
  wellSelectionError,
}: WellSelectionProps) => {
  const { AlertLargeFail: AlertFail } = Icons;
  return (
    <div className="well-selection">
      <h2>Choose wells to dispense liquid.</h2>

      <div className="wells-section">
        <div className="section-header">Wells to be filled.</div>
        <div className="selected-wells">
          {selectedWells.length > 0 ? (
            selectedWells.map((well) => (
              <div
                key={well}
                className={`well-tag ${
                  incorrectWells.includes(well) ? "incorrect-well" : ""
                }`}
              >
                {well}
                <button
                  className="remove-tag"
                  onClick={() => onRemoveWell(well)}
                >
                  ×
                </button>
              </div>
            ))
          ) : (
            <div className="no-selection">None</div>
          )}
        </div>
      </div>

      <div className="key-section">
        <div className="section-header">Key</div>
        <div className="key-container">
          <div className="key-item">
            <div className="key-circle empty"></div>
            <span className="key-label">Empty</span>
          </div>
          <div className="key-item">
            <div className="key-circle selected"></div>
            <span className="key-label">Selected</span>
          </div>
          <div className="key-item">
            <div className="key-circle filled"></div>
            <span className="key-label">Filled</span>
          </div>
          <div className="key-item">
            <div className="key-circle selected-filled"></div>
            <span className="key-label">Selected and filled</span>
          </div>
        </div>
      </div>
      {wellSelectionError && (
        <div className="error-message">
          <AlertFail className="feedback-icon" />
          <p className="feedback-message">{parse(wellSelectionError)}</p>
        </div>
      )}
    </div>
  );
};

export default WellSelection;
